export const EDITOR_TABLE_ADD_COLUMN_WITH_CUSTOM_STEP =
	'confluence.frontend.fabric.editor.add-column-custom-step';
export const EDITOR_MACRO_ADF_RENDERING =
	'confluence.frontend.fabric.editor.macro.adf.frontend.render';
export const EDITOR_PRELOAD_DRAFT_CONTENT =
	'confluence.frontend.preload.draft.body.content.next.editor';
export const EDITOR_PLUGIN_AI_FEATURE_FLAG = 'confluence.frontend.fabric.editor.editor-plugin-ai';
export const EDITOR_ENABLE_AI_UPSELL = 'platform.ai.enable-ai-upsell';
